<template>
  <div id="footer">
    <div class="footer_top">
      <ul class="container yu_fc">
        <li>
          <h3>购物指南</h3>
          <a href="">常见问题</a><br />
          <a href="">联系客服</a><br />
          <a href="">用户反馈</a>
        </li>
        <li>
          <h3>支付方式</h3>
          <a href="">微信</a><br />
          <a href="">支付宝</a>
        </li>
        <li>
          <h3>售后服务</h3>
          <a href="">售后政策</a><br />
          <a href="">退款说明</a>
        </li>
        <li>
          <h3>售后服务</h3>
          <a href="">海外购包税</a>
        </li>
      </ul>
    </div>
    <div class="footer_bottom">
      <div class="container">
        <ul class="top">
          <li class="icon_1">
            <i></i>
            <p>正品保证</p>
          </li>
          <li class="icon_2">
            <i></i>
            <p>精品不贵</p>
          </li>
          <li class="icon_3">
            <i></i>
            <p>闪电发货</p>
          </li>
          <li class="icon_4">
            <i></i>
            <p>专业康养</p>
          </li>
        </ul>
        <div class="bottom">
          <ul>
            <li><a href="">关于我们</a></li>
            <li><router-link to="/helpCenter">帮助中心</router-link></li>
            <li><a href="">售后服务</a></li>
            <li><a href="">配送与验收</a></li>
            <li><a href="">商务合作</a></li>
            <li><a href="">搜索推荐</a></li>
            <li><a href="">友情链接</a></li>
          </ul>
          <p>
            北京搜精品经贸有限公司<a href="https://beian.miit.gov.cn/#/Integrated/index">备案/许可证号：京ICP备17008054号</a>
			<a href="">互联网药品信息服务资格证书编号：(京)-非经营性-2019-0145</a>
          </p>
        </div>
      </div>
    </div>
    <div class="totop">Top</div>
  </div>
</template>

<script>
export default {
  name: "sjpFoot",
  data() {
    return {}
  },
  mounted() {
    $(window).scroll(function() {
      if ($(window).scrollTop() > 500) {
        $(".totop").fadeIn(100)
      } else {
        $(".totop").fadeOut(100)
      }
    });
    $(".totop").on("click", function() {
      $("body,html").animate({
        scrollTop: 0
      }, 500)
    })
  }
};
</script>

<style scoped>
.footer_top {
  padding: 42px 0;
  background: #fff;
  box-shadow: 0px 0px 2px 2px rgba(153,153,153,.1);
  /* border-top:1px solid rgba(218,218,218,1); */
}
.footer_top li {
  float: left;
  width: 25%;
  text-align: center;
}
.footer_top li h3 {
  font-size: 18px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  padding-bottom: 10px;
}
.footer_top li a {
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 28px;
  display: inline-block;
  vertical-align: top;
}
.footer_top li a:hover {
  color: rgba(180, 39, 45, 1);
}
.footer_bottom {
  background: #414141;
}
.footer_bottom .top {
  padding: 39px 0 36px;
  border-bottom: solid 1px #999;
  display: flex;
  justify-content: space-between;
}
.footer_bottom .top li {
  overflow: hidden;
}
.footer_bottom .top li i {
  float: left;
  width: 58px;
  height: 58px;
  background-image: url("../assets/images/icon_0.png");
  background-repeat: no-repeat;
}
.footer_bottom .top li.icon_1 i {
  background-position: -104px -31px;
}
.footer_bottom .top li.icon_2 i {
  background-position: -104px -89px;
}
.footer_bottom .top li.icon_3 i {
  background-position: -104px -147px;
}
.footer_bottom .top li.icon_4 i {
  background-position: -104px -205px;
}
.footer_bottom .top li p {
  float: left;
  color: #fff;
  font-size: 20px;
  line-height: 58px;
  padding-left: 19px;
}
.footer_bottom .bottom {
  padding: 36px 0 40px;
}
.footer_bottom .bottom ul {
  font-size: 0;
  text-align: center;
  padding-bottom: 18px;
}
.footer_bottom .bottom ul li {
  display: inline-block;
  vertical-align: top;
  padding: 0 20px;
  position: relative;
}
.footer_bottom .bottom ul li::before {
  content: "";
  width: 1px;
  height: 15px;
  background: #999;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.footer_bottom .bottom ul li:first-child::before {
  opacity: 0;
}
.footer_bottom .bottom ul li a {
  color: #999;
}
.footer_bottom .bottom ul li a:hover {
  color: #fff;
}
.footer_bottom .bottom p {
  text-align: center;
}
.footer_bottom .bottom p,
.footer_bottom .bottom p a {
  color: #999;
}
.footer_bottom .bottom p a {
  padding-left: 20px;
}
.totop {
  display: none;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  background: rgba(180, 39, 45, 1);
  border-radius: 50%;
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 9999;
}
</style>